'use es6';

import tinymce from 'tinymce';
import ReactDOM from 'react-dom';
import EmbedModal from 'rich-text-lib/components/EmbedModalV2';
import { path } from 'rich-text-lib/utils/iterables';
import { appendDivToEditor } from '../utils';
import { initPlugin, getPropsForEmbedModal, onInsertIframeEmbed, getFetchEmbedCode } from './shared';
import { HS_MEDIA } from '../constants/plugins';
import { getMceRootNode } from '../utils/namespace';
import { jsx as _jsx } from "react/jsx-runtime";
let modalDomNode = null;
export const getOpenEmbedModal = editor => {
  const apiClient = editor.getParam('apiClient');
  const {
    getUserAttributes,
    setUserAttribute
  } = path(['plugins', 'hscore', 'api'], editor);
  return () => {
    const {
      embed
    } = getPropsForEmbedModal(editor);
    if (!modalDomNode) {
      const container = appendDivToEditor(editor, 'embed-modal-container');
      if (!container) {
        console.error('Could not append div to editor.');
        return;
      }
      modalDomNode = container;
    }
    const submitHandler = modalData => {
      onInsertIframeEmbed(editor, modalData);
    };
    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(modalDomNode);
    };
    ReactDOM.render( /*#__PURE__*/_jsx(EmbedModal, {
      rootNode: getMceRootNode(),
      className: "mce-hubspot-embed--modal",
      embed: embed,
      onSubmit: submitHandler,
      onClose: handleClose,
      fetchEmbedCode: getFetchEmbedCode(apiClient),
      getUserAttributes: getUserAttributes,
      setUserAttribute: setUserAttribute,
      useIframeEmbeds: true
    }), modalDomNode);
  };
};
function hsmediaPlugin(editor) {
  initPlugin(editor, HS_MEDIA, getOpenEmbedModal(editor));
}
tinymce.PluginManager.add(HS_MEDIA, hsmediaPlugin);